<app-kpi-widget
  [title]="title"
  [icon]="'ph-duotone ph-clock-counter-clockwise'"
  [isLoading]="isLoading"
  [totalValue]="value"
  [totalCost]="totalCost"
  [percentageDifference]="percentageDifference"
  [costDifference]="difference"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  [valueFormatter]="formatValue.bind(this)"
  [costFormatter]="formatCost.bind(this)"
  [costDifferenceFormatter]="formatCostDifference.bind(this)"
  [isImageIcon]="false"
  [dropdownEnabled]="false"
  [hasFooter]="true"
  [hasValueOnly]="false"
  [hasDifference]="false"
  [hasCost]="true"
  [hasCostDifference]="true"
  [isUptrendPositive]="false"
  (clicked)="openBreakdownModal()"></app-kpi-widget>